import { Inject, Injectable, forwardRef } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { AddStockTakeModel }          from './typings/stock-take.add';
import { ApiService }                 from '../api/api.service';
import { StockTakeItem }              from './typings/stock-take.item';
import { StockTakeQuickAddComponent } from './stock-take.quick-add.component';

@Injectable({
  providedIn: 'root'
})
export class StockTakeService {
  constructor (
    @Inject(forwardRef(() => ApiService)) private apiService  : ApiService,
    private modalService: NgbModal
  ) {}

  addProduct ( stock : AddStockTakeModel ) : Promise<any> {
    return this.apiService.patch('/stock_take', [ stock ], 'stock_take');
  }

  findProduct ( itemCode : string ) : Promise<StockTakeItem> {
    return this.apiService.get('/stock_takes/find_single_item_for_stocktake', itemCode);
  }

  quickAdd () : Promise<any> {
    const modalRef = this.modalService.open(StockTakeQuickAddComponent, {
      size: 'lg'
    });

    return modalRef.result;
  }
}
